
import Sidebar from 'primevue/sidebar'
import {
  useStore
} from 'vuex'
import {
  ref,
  computed,
  defineComponent,
  onMounted
} from 'vue'
import leftMenu from '@/data/local/json/leftmenu'
import reportOnlyMenu from '@/data/local/json/reportmenu'
import DropdownListMenu from '@/views/shared-components/DropdownListMenu.vue'
import environment from '@/configs/environtment'

export default defineComponent({
  name: 'LeftPanel',
  components: {
    Sidebar,
    DropdownListMenu,
  },
  setup() {
    const items = ref(localStorage.getItem('rn') === 'External' ? reportOnlyMenu() : leftMenu())
    const store = useStore()
    const env = process.env
    const version = environment.getVersion()
    const isLoaded = ref(false)

    const activeSlider = computed({
      get: () => store.state.toggleMenu,
      set: (val) => {
        store.dispatch('setToggleMenu', val)
      }
    })
    const isMobile = ref(window.innerWidth > 1024 ? false : true)
    const hiddenSidebar = () => {
      activeSlider.value = false
    }
    const checkProhibitedRoles = (list: any) => {
      // console.log('list', list)
      if (list.length < 1) {
        // console.log('hehe')
        return true
      }
      const valSso = list.filter((role: any) => store.state?.userProfile?.resource_access['hjp-microservices'].roles.includes(role))
      if (store.state?.userProfile?.resource_access['hjp-microservices'].roles.length > 1 && valSso.length < store.state?.userProfile?.resource_access['hjp-microservices'].roles.length) {
        return true
      }
      return valSso.length < 1
    }

    onMounted(() => {
      console.log('storeX', store.state)
      store.dispatch('showLoading')
      // store.dispatch('fetchProfile')
      isLoaded.value = true
      store.dispatch('hideLoading')
    })

    return {
      activeSlider,
      hiddenSidebar,
      items,
      store,
      env,
      isMobile,
      checkProhibitedRoles,
      version,
      isLoaded
    }
  }
})
